import { ResetPasswordWithToken, TokenExists } from 'api';

export const resetPasswordWithTokenFetcher = ({ token, passwords }) => {
  return ResetPasswordWithToken.update(token, passwords);
};

export const tokenExistsFetcher = token => {
  return TokenExists.post({ token });
};
